import { isSuperAdmin } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'model-template-create',
    path: '/model-templates/create/:step?',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "model-template" */ '@/views/ModelTemplate/Mutate/Component.vue')),
    beforeEnter: isSuperAdmin,
  },
  {
    name: 'model-template-edit',
    path: '/model-templates/:id/edit/:step?',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "model-template" */ '@/views/ModelTemplate/Mutate/Component.vue')),
    beforeEnter: isSuperAdmin,
  },
  {
    name: 'model-template-posts',
    path: '/model-templates/:id/posts',
    beforeEnter: isSuperAdmin,
    redirect: to => {
      return {
        name: 'model-template-edit',
        params: { id: to.params.id, step: `posts-${to.query.collection}` },
        query: { ...to.query, collection: undefined },
      }
    },
  },

  {
    name: 'model-templates',
    path: '/model-templates',
    beforeEnter: isSuperAdmin,
    redirect: to => {
      return {
        name: 'settings',
        params: { step: `template` },
        query: { ...to.query },
      }
    },
  },
]
